var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",staticStyle:{"width":"100%"},style:(_vm.inputStyle),attrs:{"type":"file","required":_vm.item.required == '1',"accept":".jpg, .png, .pdf, .jpeg, .jfif, .webp"},on:{"change":function($event){return _vm.handleFileUpload()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }